<div *ngIf="permissions_uploadfiles || realRole === 'Client' || realRole === 'Consultant'"
     class="buttons-container fx-ai-start fx-gap-10 fx-jc-start fx-row fx-wrap">
  <button *ngIf="showBackToOverview"
          color="warn"
          mat-flat-button
          (click)="backToOverview()">
    <mat-icon>
      arrow_back
    </mat-icon>
    Back to Patient Overview
  </button>
  <button *ngIf="showUpload && upLoadConditions && isClientAndNotUploadsFolder"

          color="warn"
          mat-flat-button

          [disabled]="!selectedHub"
          [matTooltip]="!selectedHub ? 'Please select a hub first to upload files' : ''"
          (click)="openDialog($event)">
    <mat-icon>
      cloud_upload
    </mat-icon>
    Choose new files or discs to upload to your folders
  </button>

  <button *ngIf="showLibraryManagerButton && (realRole === 'Owner'||realRole==='Admin') && currentFolderName === libraryFolderName"

          color="warn"
          mat-flat-button

          [disabled]="!importFromAppsBtn"
          (click)="showLibraryManager()">
    <mat-icon>
      book
    </mat-icon>
    Manage Library
  </button>

  <button *ngIf="showAddDiagnosis && (realRole === 'Owner'||realRole==='Admin') && currentFolderName === libraryFolderName && patientType === 'external'"

          color="warn"
          mat-flat-button

          [disabled]="!importFromAppsBtn"
          (click)="addDiagnoses()">
    <mat-icon>
      medical_services
    </mat-icon>
    &nbsp;
    Add a diagnosis and medications
  </button>

  <button *ngIf="showAddConsultant && [UserRoles.admin,UserRoles.client,UserRoles.associate,UserRoles.owner].includes(realRole) && !isSpoke"
          color="warn"
          aria-hidden="false"
          aria-label="Add consultant to this case."
          mat-flat-button
          matTooltip="Add consultant to this case."
          (click)="addConsultant()">
    <mat-icon>
      person_add
    </mat-icon>
    Add {{ this.realRole==='Client' ? 'a Facility observer' : 'a Facility user' }}
  </button>

  <button *ngIf="showAddPatientUploadAccount && addClientUploadCondition"

          color="warn"
          mat-flat-button

          [disabled]="true"
          (click)="runHandleAddClientUser($event)">
    <mat-icon>
      person_add
    </mat-icon>
    Add Patient Upload Account
  </button>

  <button *ngIf="showShareFiles && (permissions_uploadfiles || realRole === 'Client' || realRole === 'Consultant')"

          color="warn"
          mat-flat-button

          [disabled]="!selectedHub"
          [matTooltip]="!selectedHub ? 'Please select a hub first to share files' : 'Share files with other users'"
          (click)="shareFiles()">
    <mat-icon>
      share
    </mat-icon>
    Share files
  </button>

  <i *ngIf="!selectedHub;"
     class="mat-small-font">
    Please select a hub first to upload and share files
  </i>

</div>
